module.exports = __webpack_public_path__ + "img/middle_4.b5496849.png";